export type SpaceDeskRuntime = 'desktop' | 'app-android' | 'app-ios' | 'mobile-browser-android' | 'mobile-browser-ios' | 'mobile-browser-other';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.wormos.spacedesk';
export const APP_STORE_URL = 'https://apps.apple.com/in/app/spacedesk-workspace/id6773883139';

function loopbackHost(hostname: string) {
  return ['127.0.0.1', 'localhost', '::1'].includes(hostname);
}

export function detectSpaceDeskRuntime(userAgent: string, appHeader = '', preview = ''): SpaceDeskRuntime {
  const ua = String(userAgent || '');
  const marker = `${appHeader} ${ua}`.toLowerCase();
  const android = /android/i.test(ua);
  const ios = /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && /applewebkit/i.test(ua) && /mobile\//i.test(ua));
  const explicitApp = /spacedesk(?:app|[-_ /]mobile)|com\.wormos\.spacedesk/.test(marker);
  const androidWebView = android && (/\bwv\b/i.test(ua) || /;\s*wv\)/i.test(ua) || /version\/4\.0.+chrome\/.+mobile\s+safari/i.test(ua));
  const iosWebView = ios && /applewebkit/i.test(ua) && !/safari\//i.test(ua) && !/crios\//i.test(ua) && !/fxios\//i.test(ua) && !/edgios\//i.test(ua);

  if (preview === 'android') return 'app-android';
  if (preview === 'ios') return 'app-ios';
  if (explicitApp || androidWebView) return android ? 'app-android' : ios ? 'app-ios' : 'desktop';
  if (iosWebView) return 'app-ios';
  if (android) return 'mobile-browser-android';
  if (ios) return 'mobile-browser-ios';
  if (/mobile|opera mini|iemobile/i.test(ua)) return 'mobile-browser-other';
  return 'desktop';
}

const preview = typeof window !== 'undefined' && loopbackHost(window.location.hostname)
  ? new URLSearchParams(window.location.search).get('spacedesk_app') || '' : '';

export const spaceDeskRuntime: SpaceDeskRuntime = typeof navigator === 'undefined'
  ? 'desktop' : detectSpaceDeskRuntime(navigator.userAgent, '', preview);

export function isMobileAppRuntime() {
  return spaceDeskRuntime === 'app-android' || spaceDeskRuntime === 'app-ios';
}

export function mobileStoreUrl(runtime = spaceDeskRuntime) {
  return runtime === 'mobile-browser-ios' ? APP_STORE_URL : PLAY_STORE_URL;
}

export function mobileInstallLandingUrl(runtime = spaceDeskRuntime, href = window.location.href) {
  const current = new URL(href, window.location.origin);
  const platform = runtime === 'mobile-browser-ios'
    ? 'ios'
    : runtime === 'mobile-browser-android'
      ? 'android'
      : 'other';
  const params = new URLSearchParams({
    platform,
    from: `${current.pathname}${current.search}${current.hash}`,
  });
  return `/install?${params.toString()}`;
}

export function applyRuntimeGate() {
  if (typeof document === 'undefined' || typeof window === 'undefined') return true;
  document.documentElement.dataset.spacedeskRuntime = spaceDeskRuntime;
  document.documentElement.classList.toggle('spacedesk-mobile-app', isMobileAppRuntime());
  document.documentElement.classList.toggle('nosivo-mobile-app', isMobileAppRuntime());
  if (!spaceDeskRuntime.startsWith('mobile-browser-')) return true;
  if (window.location.pathname !== '/install') {
    window.location.replace(mobileInstallLandingUrl());
    return false;
  }
  return true;
}
